import React, { Component } from 'react'
import { Alert } from '@softwaredev_cegeka/stix-core'
import Loader from 'src/components/Loader'
import { formatDate } from 'src/utils/utils'

class Notice extends Component {
    render() {
        const {
            title,
            isGlobalAdmin,
            globalAdminFrom,
            globalAdminUntil,
            loading,
        } = this.props
        let variant = ''
        let icon = ''
        let noticeText = ''
        if (loading) {
            return <Loader inline={true} />
        }
        if (globalAdminFrom && globalAdminUntil) {
            noticeText = `You are granted global admin access from ${formatDate(
                globalAdminFrom
            )} to ${formatDate(globalAdminUntil)}`
            if (isGlobalAdmin) {
                variant = 'secondary'
                icon = 'key'
            } else {
                variant = 'warning'
                icon = 'clock'
            }
        } else {
            noticeText = 'You have never been a global admin before'
            variant = 'warning'
            icon = 'warning'
        }
        return (
            <div>
                <Alert className="important-notice" variant={'dark'}>
                    <Alert.Heading>{title}</Alert.Heading>
                    <p>
                        Submitting this request will grant you global admin
                        authority for Horizon until next Sunday 11 PM CET. After
                        submission you will need to log out of Horizon and log
                        in again. Please be very careful with the actions you
                        perform while you are a global admin. All (impersonated)
                        actions will be logged.
                    </p>
                </Alert>
                <Alert className="valid-period" icon={icon} variant={variant}>
                    <p>{noticeText}</p>
                </Alert>
            </div>
        )
    }
}

export default Notice
